import React from "react";

import "./Header.css";
import SubHeading from "../../components/SubHeading/SubHeading";
import { images } from "../../constants";

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
    <div className="app__wrapper_info">
      <SubHeading title="Authentic Vietnamese Flavors" />
      <h1 className="app__header-h1"> Pho Ha Long</h1>
      <p className="p__opensans">
        Welcome to Pho Ha Long. We aim to delight your taste buds using
        traditional techniques and the freshest ingredients. Join us for a
        casual and comfortable eating experience.
      </p>
      <button
        type="button"
        className="custom__button"
        onClick={() =>
          document.getElementById("menu").scrollIntoView({ behavior: "smooth" })
        }
      >
        Explore Menu
      </button>
    </div>

    <div className="app__wrapper_img">
      <img src={images.welcome} alt="header_img" />
    </div>
  </div>
);

export default Header;
